var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"app"}},[(_vm.isAuthenticated)?_c('drawer'):_vm._e(),_c('toolbar'),_c('v-content',[_c('v-container',{attrs:{"fluid":""}},[_c('router-view'),_c('loading')],1)],1),_c('peu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }